"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection244sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-2 col-lg-4 col-md-4" | "col-xl-3 col-lg-4 col-md-4" */
    className: string;
    /** Detected variants: "Company" | "Veterinary Services" */
    h50Text: ReactNode;
    /** Detected variants: "footer-widget" */
    div0ClassName?: string;
    /** Detected variants: "footer-title" */
    h50ClassName?: string;
    footerMenuItems?: FooterSectionUls2Item[];
};

type FooterSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Clinics" | "Hospitals" | "Specialities" | "Contact Us" | "Pet Health Checkups" | "Vaccinations & Preventions" | "Surgery & Orthopedics" | "Dental Care for Pets" | "Emergency & Critical Care" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.clinics" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.contactUs" */
    href: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeSixFooterSectionGeneratedProps = {
    divDiv0H50H5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection244sItem) => Partial<ComponentProps<"h5">>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "logo" */
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-06.svg" */
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "We’re a trusted veterinary clinic dedicated to keeping" */
    footerDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "your pets healthy and happy." */
    footerDiv0Div0Div0Div0Div0P0Span0SpanText?: ReactNode;
    /** Default: "footer-img-1" */
    footerDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-img-1.png" */
    footerDiv0ImageWithBasePath0ImageSrc?: string;
    footerDiv0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-icon" */
    footerDiv0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-6.png" */
    footerDiv0ImageWithBasePath1ImageSrc?: string;
    footerDiv0ImageWithBasePath1ImageVisible?: boolean;
    footerDiv0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-icon" */
    footerDiv0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/foot-prints-4.png" */
    footerDiv0ImageWithBasePath2ImageSrc?: string;
    footerDiv0ImageWithBasePath2ImageVisible?: boolean;
    footerDiv0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerDiv1Div0Div0Div0ClassName?: string;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv1Div0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "all_routes.termsAndCondition" */
    footerDiv1Div0Div0Div0Div1Div0Link0LinkHref?: string;
    /** Default: "Terms & Conditions" */
    footerDiv1Div0Div0Div0Div1Div0Link0LinkText?: ReactNode;
    footerDiv1Div0Div0Div0Div1Div0Link0LinkVisible?: boolean;
    footerDiv1Div0Div0Div0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.privacyPolicy" */
    footerDiv1Div0Div0Div0Div1Div0Link1LinkHref?: string;
    /** Default: "Privacy Policy" */
    footerDiv1Div0Div0Div0Div1Div0Link1LinkText?: ReactNode;
    footerDiv1Div0Div0Div0Div1Div0Link1LinkVisible?: boolean;
    footerDiv1Div0Div0Div0Div1Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div0Div1Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "/" */
    footerDiv1Div0Div0Div0Div1Div0Span0SpanText?: ReactNode;
    footerSectionUls2LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection244s: FooterSection244sItem[];
    footerSectionUls: FooterSectionUlsItem[];
    footerSection244sItemWrapper?: (item: FooterSection244sItem, content: ReactNode) => ReactNode;
    footerSection244sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection244sH5Visible?: boolean;
    footerSection244sH5Renderer?: (item: FooterSection244sItem, defaultNode: ReactNode) => ReactNode;
    footerSection244sH5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection244sItem) => Partial<ComponentProps<"h5">>);
    footerSectionUls2ItemWrapper?: (item: FooterSectionUls2Item, content: ReactNode) => ReactNode;
    footerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkVisible?: boolean;
    footerSectionUls2LinkRenderer?: (item: FooterSectionUls2Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeSixFooterSectionGenerated: FC<HomeSixFooterSectionGeneratedProps> = ({
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "logo",
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-06.svg",
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    footerDiv0Div0Div0Div0Div0P0PText = "We’re a trusted veterinary clinic dedicated to keeping",
    footerDiv0Div0Div0Div0Div0P0Span0SpanText = "your pets healthy and happy.",
    footerDiv0ImageWithBasePath0ImageAlt = "footer-img-1",
    footerDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-img-1.png",
    footerDiv0ImageWithBasePath0ImageVisible,
    footerDiv0ImageWithBasePath0ImageRenderer,
    footerDiv0ImageWithBasePath0ImageProps,
    footerDiv0ImageWithBasePath1ImageAlt = "banner-icon",
    footerDiv0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/banner-icon-6.png",
    footerDiv0ImageWithBasePath1ImageVisible,
    footerDiv0ImageWithBasePath1ImageRenderer,
    footerDiv0ImageWithBasePath1ImageProps,
    footerDiv0ImageWithBasePath2ImageAlt = "banner-icon",
    footerDiv0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/icons/foot-prints-4.png",
    footerDiv0ImageWithBasePath2ImageVisible,
    footerDiv0ImageWithBasePath2ImageRenderer,
    footerDiv0ImageWithBasePath2ImageProps,
    footerDiv1Div0Div0Div0Div0Div0P0PText = "Copyright © 2026 Doccure. All Rights Reserved",
    footerDiv1Div0Div0Div0Div1Div0Link0LinkHref = "all_routes.termsAndCondition",
    footerDiv1Div0Div0Div0Div1Div0Link0LinkText = "Terms & Conditions",
    footerDiv1Div0Div0Div0Div1Div0Link0LinkVisible,
    footerDiv1Div0Div0Div0Div1Div0Link0LinkRenderer,
    footerDiv1Div0Div0Div0Div1Div0Link0LinkProps,
    footerDiv1Div0Div0Div0Div1Div0Link1LinkHref = "all_routes.privacyPolicy",
    footerDiv1Div0Div0Div0Div1Div0Link1LinkText = "Privacy Policy",
    footerDiv1Div0Div0Div0Div1Div0Link1LinkVisible,
    footerDiv1Div0Div0Div0Div1Div0Link1LinkRenderer,
    footerDiv1Div0Div0Div0Div1Div0Link1LinkProps,
    footerDiv1Div0Div0Div0Div1Div0Span0SpanText = "/",
    divDiv0H50H5Props,
    footerSectionUls2LiLink0LinkProps,
    liLink0LinkProps,
    footerDiv0Div0Div0ClassName,
    footerDiv1Div0Div0Div0ClassName,
    footerSection244s,
    footerSectionUls,
    footerSection244sItemWrapper,
    footerSection244sRenderer,
    footerSection244sH5Visible,
    footerSection244sH5Renderer,
    footerSection244sH5Props,
    footerSectionUls2ItemWrapper,
    footerSectionUls2Renderer,
    footerSectionUls2LinkVisible,
    footerSectionUls2LinkRenderer,
    footerSectionUls2LinkProps,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
}) => {
    return (
        <footer className="footer-six footer">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-xl-5 col-lg-4 col-md-4">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    {renderNode(footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} {...(footerDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <p className="description">
                                    {footerDiv0Div0Div0Div0Div0P0PText}
                                    <span className="d-block">{footerDiv0Div0Div0Div0Div0P0Span0SpanText}</span>
                                    {" "}
                                </p>
                                <div className="footer-about-content">
                                    <ul className="social-icon">
                                        {renderCollectionNode(
                                            footerSectionUls,
                                            (item: FooterSectionUlsItem) => (
                                                <li key={item.key}>
                                                    {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                            <i className={item.className} />
                                                        </SmartLink>
                                                    ))}
                                                </li>
                                            ),
                                            footerSectionUlsItemWrapper,
                                            footerSectionUlsRenderer
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {renderCollectionNode(
                            footerSection244s,
                            (item: FooterSection244sItem) => (
                                <div className={item.className} key={item.key}>
                                    <div className={item.div0ClassName ?? "footer-widget"}>
                                        {renderItemNode(footerSection244sH5Visible, footerSection244sH5Renderer, item, (
                                            <h5 className={item.h50ClassName ?? "footer-title"} {...(typeof footerSection244sH5Props === "function" ? footerSection244sH5Props(item) : (footerSection244sH5Props ?? {}))} {...(typeof divDiv0H50H5Props === "function" ? divDiv0H50H5Props(item) : (divDiv0H50H5Props ?? {}))}>{item.h50Text}</h5>
                                        ))}
                                        <ul className="footer-menu">
                                            {renderCollectionNode(
                                                item.footerMenuItems ?? [],
                                                (item: FooterSectionUls2Item) => (
                                                    <li key={item.key}>
                                                        {renderItemNode(footerSectionUls2LinkVisible, footerSectionUls2LinkRenderer, item, (
                                                            <SmartLink href={item.href} {...(typeof footerSectionUls2LinkProps === "function" ? footerSectionUls2LinkProps(item) : (footerSectionUls2LinkProps ?? {}))} {...(typeof footerSectionUls2LiLink0LinkProps === "function" ? footerSectionUls2LiLink0LinkProps(item) : (footerSectionUls2LiLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                        ))}
                                                    </li>
                                                ),
                                                footerSectionUls2ItemWrapper,
                                                footerSectionUls2Renderer
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            ),
                            footerSection244sItemWrapper,
                            footerSection244sRenderer
                        )}
                    </div>
                </div>
                {renderNode(footerDiv0ImageWithBasePath0ImageVisible, footerDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath0ImageSrc} alt={footerDiv0ImageWithBasePath0ImageAlt} className="img-fluid footer-img-1" {...(footerDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(footerDiv0ImageWithBasePath1ImageVisible, footerDiv0ImageWithBasePath1ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath1ImageSrc} alt={footerDiv0ImageWithBasePath1ImageAlt} className="img-fluid icon-one" {...(footerDiv0ImageWithBasePath1ImageProps ?? {})} />
                ))}
                {renderNode(footerDiv0ImageWithBasePath2ImageVisible, footerDiv0ImageWithBasePath2ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath2ImageSrc} alt={footerDiv0ImageWithBasePath2ImageAlt} className="img-fluid icon-two" {...(footerDiv0ImageWithBasePath2ImageProps ?? {})} />
                ))}
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        <div className={footerDiv1Div0Div0Div0ClassName ?? "row justify-content-center g-4"}>
                            <div className="col-lg-6">
                                <div className="copyright-text">
                                    <p className="mb-0">{footerDiv1Div0Div0Div0Div0Div0P0PText}</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="footer-links">
                                    {renderNode(footerDiv1Div0Div0Div0Div1Div0Link0LinkVisible, footerDiv1Div0Div0Div0Div1Div0Link0LinkRenderer, (
                                        <SmartLink href={footerDiv1Div0Div0Div0Div1Div0Link0LinkHref} {...(footerDiv1Div0Div0Div0Div1Div0Link0LinkProps ?? {})}>{footerDiv1Div0Div0Div0Div1Div0Link0LinkText}</SmartLink>
                                    ))}
                                    <span>{footerDiv1Div0Div0Div0Div1Div0Span0SpanText}</span>
                                    {renderNode(footerDiv1Div0Div0Div0Div1Div0Link1LinkVisible, footerDiv1Div0Div0Div0Div1Div0Link1LinkRenderer, (
                                        <SmartLink href={footerDiv1Div0Div0Div0Div1Div0Link1LinkHref} {...(footerDiv1Div0Div0Div0Div1Div0Link1LinkProps ?? {})}>{footerDiv1Div0Div0Div0Div1Div0Link1LinkText}</SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default HomeSixFooterSectionGenerated;
